import { Button } from '@mantine/core';
import classnames from 'classnames';

import styles from './FinanceTile.module.scss';
import { FinanceTilePrimaryAction, Props } from './FinanceTile.types';

const FinanceTile = ({
  icon,
  title,
  description,
  kpi,
  onClick,
  primaryAction,
  secondaryActions,
  variant = 'medium',
}: Props) => {
  const actions = [...(primaryAction ? [primaryAction] : []), ...(secondaryActions ?? [])];

  // The tile itself navigates: an action button must not trigger it too.
  const handleAction =
    (action: FinanceTilePrimaryAction) => (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      action.onClick();
    };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={classnames(styles.tile, variant === 'large' ? styles.large : styles.medium)}
    >
      <div className={styles.iconWrap}>{icon}</div>
      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
        {kpi && <div className={styles.kpi}>{kpi}</div>}
      </div>
      {actions.length > 0 && (
        <div className={styles.actionRow}>
          {actions.map((action, index) => (
            <Button
              key={action.label}
              onClick={handleAction(action)}
              disabled={action.disabled}
              variant={action.variant ?? (index === 0 ? 'filled' : 'light')}
              size="md"
              fw={500}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FinanceTile;
